import {
    GET_SHIPPING_ZONE_LISTING,
    GET_SHIPPING_ZONE_LISTING_SUCCESS,
    GET_SHIPPING_ZONE_LISTING_FAIL,
    GET_SHIPPING_ZONE_DETAILS,
    GET_SHIPPING_ZONE_DETAILS_SUCCESS,
    GET_SHIPPING_ZONE_DETAILS_FAIL,
    ADD_SHIPPING_ZONE,
    ADD_SHIPPING_ZONE_SUCCESS,
    ADD_SHIPPING_ZONE_FAIL,
    UPDATE_SHIPPING_ZONE,
    UPDATE_SHIPPING_ZONE_SUCCESS,
    UPDATE_SHIPPING_ZONE_FAIL,
    DELETE_SHIPPING_ZONE,
    DELETE_SHIPPING_ZONE_SUCCESS,
    DELETE_SHIPPING_ZONE_FAIL,
    EXPORT_SHIPPING_ZONE,
    EXPORT_SHIPPING_ZONE_SUCCESS,
    EXPORT_SHIPPING_ZONE_FAIL,
    RESET_SHIPPING_ZONE_STATE,
    RESET_SHIPPING_ZONE_ACTION_STATE,
    UPDATE_SHIPPING_ZONE_ACTIVATION,
    UPDATE_SHIPPING_ZONE_ACTIVATION_SUCCESS,
    UPDATE_SHIPPING_ZONE_ACTIVATION_FAIL,
} from "./actionTypes";

export const getShippingZoneListing = (payload) => ({
    type: GET_SHIPPING_ZONE_LISTING,
    payload: payload
});

export const getShippingZoneListingSuccess = categories => ({
    type: GET_SHIPPING_ZONE_LISTING_SUCCESS,
    payload: categories,
});

export const getShippingZoneListingFail = error => ({
    type: GET_SHIPPING_ZONE_LISTING_FAIL,
    payload: error,
});

export const getShippingZoneDetails = shippingZoneId => ({
    type: GET_SHIPPING_ZONE_DETAILS,
    payload: shippingZoneId,
});

export const getShippingZoneDetailsSuccess = shippingZone => ({
    type: GET_SHIPPING_ZONE_DETAILS_SUCCESS,
    payload: shippingZone,
});

export const getShippingZoneDetailsFail = error => ({
    type: GET_SHIPPING_ZONE_DETAILS_FAIL,
    payload: error,
});

export const createShippingZone = shippingZone => ({
    type: ADD_SHIPPING_ZONE,
    payload: shippingZone,
});

export const createShippingZoneSuccess = shippingZone => ({
    type: ADD_SHIPPING_ZONE_SUCCESS,
    payload: shippingZone,
});

export const createShippingZoneFail = error => ({
    type: ADD_SHIPPING_ZONE_FAIL,
    payload: error,
});

export const updateShippingZone = shippingZone => ({
    type: UPDATE_SHIPPING_ZONE,
    payload: shippingZone,
});

export const updateShippingZoneSuccess = shippingZone => ({
    type: UPDATE_SHIPPING_ZONE_SUCCESS,
    payload: shippingZone,
});

export const updateShippingZoneFail = error => ({
    type: UPDATE_SHIPPING_ZONE_FAIL,
    payload: error,
});

export const updateShippingZoneActivation = shippingZone => ({
    type: UPDATE_SHIPPING_ZONE_ACTIVATION,
    payload: shippingZone,
});

export const updateShippingZoneActivationSuccess = shippingZone => ({
    type: UPDATE_SHIPPING_ZONE_ACTIVATION_SUCCESS,
    payload: shippingZone,
});

export const updateShippingZoneActivationFail = error => ({
    type: UPDATE_SHIPPING_ZONE_ACTIVATION_FAIL,
    payload: error,
});

export const deleteShippingZone = ({ id, multiple }) => ({
    type: DELETE_SHIPPING_ZONE,
    payload: { id, multiple },
});

export const deleteShippingZoneSuccess = shippingZoneId => ({
    type: DELETE_SHIPPING_ZONE_SUCCESS,
    payload: shippingZoneId,
});

export const deleteShippingZoneFail = error => ({
    type: DELETE_SHIPPING_ZONE_FAIL,
    payload: error,
});

export const exportShippingZone = (payload) => ({
    type: EXPORT_SHIPPING_ZONE,
    payload: payload
});

export const exportShippingZoneSuccess = data => ({
    type: EXPORT_SHIPPING_ZONE_SUCCESS,
    payload: data,
});

export const exportShippingZoneFail = error => ({
    type: EXPORT_SHIPPING_ZONE_FAIL,
    payload: error,
});

//reset
export const resetShippingZoneState = () => {
    return {
        type: RESET_SHIPPING_ZONE_STATE,
    }
}
//reset action
export const resetShippingZoneActionState = () => {
    return {
        type: RESET_SHIPPING_ZONE_ACTION_STATE,
    }
}

